module.exports = __webpack_public_path__ + "img/PPMP19.1838a95e.png";